module.exports = __webpack_public_path__ + "static/media/github.5bb1fe61.svg";